module.exports = __webpack_public_path__ + "img/chefs_3.54fb99c9.png";